import { memo } from 'react';

import { InceptIcon, InceptIconProps } from '../InceptIcon';

const IconAssetOtherComponent: React.FC<InceptIconProps> = ({
  color = 'var(--chakra-colors-brand-primary-fg, currentColor)',
  brandColor = 'var(--chakra-colors-brand-primary-solid)',
  fillColor = 'var(--chakra-colors-brand-primary-contrast)',
  viewBox = '0 0 80 80',
  ...props
}: InceptIconProps) => (
  <InceptIcon viewBox={viewBox} {...props}>
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="0.75"
    >
      <g clipPath="url(#a)">
        <path
          d="M8.428 41.299c0 .676.21 1.352.629 1.994v2.743c-.42-.642-.63-1.318-.63-1.994z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M9.057 46.464a.44.44 0 0 1-.36-.193c-.466-.71-.701-1.46-.701-2.23V41.3a.43.43 0 0 1 .428-.428.43.43 0 0 1 .427.428c0 .599.189 1.194.561 1.758a.4.4 0 0 1 .068.236v2.743a.43.43 0 0 1-.303.41.4.4 0 0 1-.124.018z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m9.057 43.293 5.763-3.308v2.743l-5.763 3.308z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M9.057 46.464a.5.5 0 0 1-.214-.056.43.43 0 0 1-.214-.372v-2.743a.43.43 0 0 1 .214-.373l5.764-3.307a.43.43 0 0 1 .642.372v2.743a.43.43 0 0 1-.214.372L9.27 46.412a.4.4 0 0 1-.214.056zm.428-2.923v1.754l4.908-2.82v-1.754z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m14.82 39.985 4.207.864v2.743l-4.206-.864z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M19.027 44.02c-.03 0-.055 0-.085-.008l-4.207-.865a.43.43 0 0 1-.342-.42v-2.742a.425.425 0 0 1 .513-.42l4.207.865a.43.43 0 0 1 .342.42v2.742c0 .129-.06.248-.158.334a.42.42 0 0 1-.27.094m-3.778-1.643 3.35.689v-1.87l-3.35-.689z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m19.027 40.85 1.506 2.417v2.743l-1.506-2.418z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M20.533 46.438a.43.43 0 0 1-.364-.201l-1.506-2.418a.42.42 0 0 1-.064-.227V40.85a.425.425 0 0 1 .787-.227l1.507 2.418a.42.42 0 0 1 .064.227v2.743a.427.427 0 0 1-.428.428zm-1.078-2.97.65 1.044v-1.125l-.65-1.044z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M27.444 39.382c6.32-3.633 38.798-22.281 39.996-22.966.72-.415 1.074-.959 1.074-1.52v2.744c0 .56-.355 1.108-1.074 1.519-1.194.684-33.672 19.333-39.996 22.966z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M27.444 42.548a.4.4 0 0 1-.214-.056.43.43 0 0 1-.214-.372v-2.743a.43.43 0 0 1 .214-.372c4.24-2.435 20.252-11.63 30.698-17.625l9.298-5.34c.556-.317.86-.728.86-1.147a.43.43 0 0 1 .428-.428.43.43 0 0 1 .428.428v2.742c0 .74-.458 1.413-1.288 1.892-1.194.684-33.672 19.333-39.996 22.966a.4.4 0 0 1-.215.055m.427-2.922v1.754c7.613-4.369 38.195-21.93 39.355-22.598.556-.32.86-.727.86-1.15v-1.143a4 4 0 0 1-.432.29l-9.299 5.341c-10.274 5.9-25.94 14.895-30.484 17.501z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M14.774 46.575c3.496.757 7.587.33 10.398-1.284 1.913-1.1 2.867-2.537 2.867-3.975v2.743c0 1.437-.954 2.875-2.867 3.975-2.811 1.613-6.902 2.041-10.398 1.284z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M18.223 50.105c-1.19 0-2.388-.12-3.54-.368a.43.43 0 0 1-.337-.42v-2.742c0-.129.06-.253.158-.334a.43.43 0 0 1 .36-.086c3.504.758 7.466.274 10.094-1.236 1.707-.98 2.649-2.264 2.649-3.603a.43.43 0 0 1 .427-.428.43.43 0 0 1 .428.428v2.743c0 1.66-1.095 3.205-3.08 4.347-1.93 1.108-4.524 1.703-7.164 1.703zm-3.021-1.138c3.419.659 7.214.154 9.756-1.305 1.707-.98 2.649-2.264 2.649-3.603v-.291c-.523.701-1.271 1.343-2.226 1.895-2.67 1.537-6.615 2.08-10.184 1.434v1.87z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M8.428 41.299c0-1.438.954-2.88 2.867-3.98 2.785-1.6 6.82-2.028 10.29-1.305 6.325-3.629 38.803-22.277 39.997-22.961 1.506-.865 4.04-.813 5.657.115.847.488 1.275 1.117 1.275 1.729 0 .56-.355 1.108-1.074 1.519-1.194.685-33.672 19.333-39.996 22.966.393.624.59 1.28.59 1.938 0 1.438-.954 2.876-2.867 3.975-2.81 1.613-6.902 2.041-10.398 1.284l5.764-3.312-1.506-2.418-4.206-.864-5.764 3.312c-.42-.642-.63-1.318-.63-1.994z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M18.223 47.362c-1.19 0-2.388-.12-3.54-.368a.43.43 0 0 1-.333-.35.43.43 0 0 1 .21-.437l5.379-3.09-1.177-1.883-3.868-.795-5.623 3.23a.43.43 0 0 1-.57-.137C8.236 42.822 8 42.073 8 41.303c0-1.664 1.095-3.21 3.08-4.347 2.727-1.567 6.805-2.106 10.433-1.387 6.65-3.821 38.67-22.208 39.855-22.889 1.652-.95 4.322-.898 6.085.116.959.552 1.49 1.297 1.49 2.101 0 .74-.459 1.412-1.289 1.891l-9.298 5.34A89038 89038 0 0 0 28.03 39.545c.291.574.437 1.169.437 1.776 0 1.66-1.096 3.205-3.081 4.348-1.93 1.108-4.523 1.703-7.163 1.703zm-2.213-1.001c3.197.44 6.603-.094 8.948-1.438 1.707-.98 2.649-2.264 2.649-3.603 0-.582-.176-1.155-.527-1.707a.43.43 0 0 1-.055-.334.46.46 0 0 1 .2-.27c4.241-2.434 20.254-11.63 30.699-17.625l9.298-5.34c.556-.317.86-.728.86-1.147 0-.48-.385-.971-1.057-1.357-1.497-.86-3.842-.91-5.233-.115-1.194.685-33.672 19.333-39.996 22.966a.43.43 0 0 1-.3.047c-3.474-.728-7.398-.231-9.991 1.258-1.712.984-2.653 2.263-2.653 3.607 0 .48.12.954.359 1.412l5.396-3.098a.43.43 0 0 1 .3-.047l4.206.864a.45.45 0 0 1 .278.193l1.506 2.418a.425.425 0 0 1-.15.594l-4.74 2.722z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M64.128 15.97c.82 0 1.485-.38 1.485-.85s-.665-.852-1.485-.852-1.485.381-1.485.851.665.852 1.485.852"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M64.128 16.403c-1.091 0-1.913-.552-1.913-1.28 0-.727.822-1.283 1.913-1.283s1.913.552 1.913 1.284c0 .731-.822 1.28-1.913 1.28m0-1.707c-.646 0-1.057.278-1.057.428s.41.423 1.057.423c.646 0 1.057-.278 1.057-.423 0-.146-.41-.428-1.057-.428"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m59.678 32.843 3.946-3.265v2.285l-3.946 3.261z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M59.678 35.552a.5.5 0 0 1-.184-.039.43.43 0 0 1-.244-.389v-2.28c0-.13.056-.249.154-.33l3.945-3.26a.426.426 0 0 1 .698.334v2.28a.43.43 0 0 1-.154.33l-3.946 3.26a.43.43 0 0 1-.273.098zm.428-2.508v1.173l3.09-2.555V30.49z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M56.144 34.088c0 .527.158 1.053.47 1.554v2.28c-.312-.5-.47-1.026-.47-1.553z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M56.614 38.355a.43.43 0 0 1-.363-.201c-.356-.57-.54-1.169-.54-1.78v-2.281a.43.43 0 0 1 .428-.428.43.43 0 0 1 .428.428c0 .45.137.898.407 1.326a.42.42 0 0 1 .064.227v2.28a.427.427 0 0 1-.428.429z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m28.809 58.415 32.47-20.069v2.28l-32.47 20.07z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M28.809 61.124a.425.425 0 0 1-.428-.428v-2.281c0-.15.077-.287.201-.364l32.474-20.069a.42.42 0 0 1 .432-.008.43.43 0 0 1 .218.372v2.28c0 .15-.077.288-.201.365L29.031 61.059a.42.42 0 0 1-.226.065zm.428-2.474v1.275l31.618-19.538v-1.275z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M61.278 38.346c2.765.582 5.978.235 8.195-1.048 1.523-.882 2.28-2.037 2.28-3.193v2.281c0 1.156-.757 2.311-2.28 3.192-2.217 1.284-5.43 1.63-8.195 1.049z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M63.983 41.333a13.7 13.7 0 0 1-2.794-.287.43.43 0 0 1-.338-.42v-2.28c0-.128.06-.252.158-.334a.42.42 0 0 1 .36-.085c2.746.577 5.844.184 7.894-1.001 1.335-.775 2.067-1.776 2.067-2.82a.43.43 0 0 1 .428-.428.43.43 0 0 1 .428.428v2.28c0 1.365-.886 2.632-2.495 3.56-1.562.903-3.607 1.387-5.708 1.387m-2.277-1.057c2.662.48 5.589.068 7.553-1.065 1.335-.775 2.067-1.776 2.067-2.82v-.06q-.617.746-1.64 1.339c-2.122 1.232-5.138 1.673-7.984 1.194v1.412z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m11.671 59.951 6.376-2.589v2.281l-6.376 2.589z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M11.672 62.66a.427.427 0 0 1-.428-.428v-2.28c0-.176.107-.33.265-.399l6.376-2.589a.427.427 0 0 1 .586.398v2.281c0 .175-.107.33-.265.398l-6.376 2.585a.4.4 0 0 1-.163.03zm.428-2.422v1.356l5.52-2.238V58l-5.52 2.242z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m18.047 57.362 4.622 1.862v2.28l-4.622-1.861z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M22.668 61.932a.4.4 0 0 1-.158-.03l-4.621-1.857a.43.43 0 0 1-.27-.398v-2.28a.426.426 0 0 1 .586-.398l4.622 1.857c.162.064.27.222.27.398v2.28a.44.44 0 0 1-.189.356.44.44 0 0 1-.24.072m-4.193-2.576 3.765 1.515v-1.356L18.476 58v1.36z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m22.669 59.224 1.433 3.15v2.28l-1.433-3.15z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M24.102 65.082a.43.43 0 0 1-.39-.253l-1.433-3.15a.4.4 0 0 1-.038-.175v-2.28a.429.429 0 0 1 .817-.18l1.433 3.15a.4.4 0 0 1 .039.175v2.28a.43.43 0 0 1-.428.428zm-1.006-3.672.578 1.271v-.214l-.578-1.27z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M17.615 65.005c3.098.62 6.67.218 9.144-1.216 1.724-.997 2.585-2.306 2.585-3.615v2.28c0 1.31-.86 2.62-2.585 3.616-2.473 1.434-6.046 1.836-9.144 1.215z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M20.529 68c-1.001 0-2.011-.094-3-.295a.42.42 0 0 1-.342-.42v-2.28c0-.129.056-.248.158-.33a.44.44 0 0 1 .356-.09c3.085.617 6.56.159 8.844-1.168 1.528-.886 2.37-2.037 2.37-3.243a.43.43 0 0 1 .429-.428.43.43 0 0 1 .428.428v2.28c0 1.528-.993 2.94-2.799 3.988C25.22 67.462 22.908 68 20.533 68zm-2.486-1.07c3 .518 6.299.047 8.502-1.232 1.498-.869 2.337-1.99 2.37-3.17-.465.602-1.12 1.154-1.942 1.63-2.366 1.369-5.747 1.878-8.93 1.356v1.416"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M11.671 59.951c.09-1.24.942-2.465 2.572-3.41 2.512-1.455 6.15-1.845 9.281-1.19l33.09-19.71c-.312-.5-.47-1.026-.47-1.553 0-1.155.757-2.31 2.28-3.192 1.442-.834 3.308-1.27 5.195-1.318l-3.945 3.26 2.833 2.363 4.805.736 4.014-3.32c.286.479.428.984.428 1.484 0 1.156-.758 2.311-2.281 3.192-2.217 1.284-5.43 1.63-8.194 1.049L28.805 58.41c.355.569.535 1.163.535 1.758 0 1.31-.86 2.62-2.585 3.616-2.473 1.434-6.046 1.836-9.144 1.215l6.491-2.631-1.433-3.15-4.622-1.857z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M20.53 65.72c-1.002 0-2.012-.095-3-.292a.43.43 0 0 1-.077-.817l6.076-2.465-1.177-2.589-4.3-1.728-6.218 2.52a.427.427 0 0 1-.586-.428c.103-1.438 1.091-2.768 2.786-3.748 2.46-1.425 6.14-1.917 9.418-1.271l32.593-19.414a3.2 3.2 0 0 1-.325-1.4c0-1.364.886-2.631 2.495-3.564 1.442-.839 3.363-1.326 5.4-1.373a.42.42 0 0 1 .41.278.43.43 0 0 1-.128.479l-3.547 2.935 2.345 1.956 4.497.684 3.864-3.196a.42.42 0 0 1 .347-.09.43.43 0 0 1 .295.201c.325.544.488 1.117.488 1.708 0 1.365-.886 2.631-2.495 3.56-2.212 1.28-5.387 1.711-8.331 1.13l-31.982 19.76c.257.522.39 1.061.39 1.613 0 1.528-.993 2.94-2.799 3.988-1.754 1.019-4.065 1.558-6.44 1.558zm-1.28-.916c2.648.222 5.383-.279 7.296-1.387 1.527-.886 2.37-2.037 2.37-3.243 0-.522-.158-1.036-.47-1.532a.44.44 0 0 1-.056-.326.42.42 0 0 1 .192-.265l32.474-20.069a.42.42 0 0 1 .312-.055c2.748.578 5.846.184 7.895-1.001 1.335-.775 2.067-1.776 2.067-2.82q0-.411-.15-.81l-3.594 2.975a.44.44 0 0 1-.338.094l-4.806-.732a.43.43 0 0 1-.21-.094L59.4 33.177a.43.43 0 0 1-.154-.33c0-.128.056-.248.154-.329l2.91-2.405c-1.39.176-2.666.574-3.676 1.16-1.335.774-2.067 1.776-2.067 2.824 0 .45.137.899.407 1.327.06.098.081.214.051.33a.42.42 0 0 1-.197.264l-33.09 19.71a.43.43 0 0 1-.308.051c-3.123-.659-6.65-.21-8.977 1.138-1.13.655-1.891 1.468-2.204 2.34l5.631-2.284a.42.42 0 0 1 .321 0l4.622 1.857c.102.043.184.12.23.218l1.434 3.15a.43.43 0 0 1-.227.573l-5.015 2.033z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <clipPath id="a">
        <path
          d="M8 12h64.186v56H8z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
      </clipPath>
    </g>
  </InceptIcon>
);

export const IconAssetOther = memo(IconAssetOtherComponent);
